import { render, staticRenderFns } from "./CoThreeDotsMenu.vue?vue&type=template&id=0f90f01a&scoped=true&"
import script from "./CoThreeDotsMenu.vue?vue&type=script&lang=ts&"
export * from "./CoThreeDotsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CoThreeDotsMenu.vue?vue&type=style&index=0&id=0f90f01a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90f01a",
  null
  
)

export default component.exports